import { Container, Card } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { FaTwitterSquare } from "react-icons/fa";

const ContactUs = () => {
  return (
    <Container>
      <Helmet>
        <title>
           تطبيق أكواد: تواصل معنا
        </title>
      </Helmet>
      <Card className="my-5 text-right">
        <Card.Header as="h5">تواصل معنا</Card.Header>
        <Card.Body>
          <Card.Title>البريد الإلكتروني: hello@akoad.app</Card.Title>
          <Card.Title>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://twitter.com/AkoadApp"
            >
              <FaTwitterSquare color="#00acee" size="2em" />
            </a>
          </Card.Title>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContactUs;
